import { AfterViewInit, Component, ContentChildren, ElementRef, HostListener, Input, QueryList, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ButtonBaseComponent } from '../button-base.component';
import { ButtonComponent } from '../button.component';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { MenuItemComponent } from '../menu-button/menu-item/menu-item.component';

@Component({
    selector: 'lib-split-button',
    templateUrl: './split-button.component.html',
    styleUrls: ['./split-button.component.scss']
})
export class SplitButtonComponent extends ButtonBaseComponent implements AfterViewInit {

    @ViewChild('container', { static: false }) container!: ElementRef<HTMLElement>;
    @ViewChild('button', { static: false }) buttonRef!: ButtonComponent;
    @ViewChild(IconButtonComponent, { static: false }) iconButtonRef!: IconButtonComponent;
    @ViewChild(MatMenuTrigger, { static: false }) menuTriggerRef!: MatMenuTrigger;
    @ContentChildren(MenuItemComponent) menuItemComponents!: QueryList<MenuItemComponent>;
    @Input() hasBackdrop: boolean = true;

    private _menuWidth: number = 0;

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.ResizeButton();
        })

    }
    OpenMenuFromButton(menu: MatMenuTrigger): void {
        menu.toggleMenu();
    }

    MenuItemClicked(item: MenuItemComponent, event: MouseEvent) {
        if (!item.disabled) {
            item.clicked.emit();
        }

        if (item.stopPropagation) {
            event.stopPropagation();
        }
        this.menuTriggerRef.closeMenu();
    }

    private ResizeButton() {
        const element = this.container!.nativeElement!;
        const containerWidth = element.parentElement!.parentElement!.clientWidth;
        const containerPadding = Number(getComputedStyle(element.parentElement!.parentElement!).paddingRight.replace("px", "")) * 2;
        const iconButtonWidth = Number(getComputedStyle(this.iconButtonRef.button?.nativeElement).width.replace("px", ""));
        if (this._stretch) {
            const width = containerWidth - containerPadding - iconButtonWidth;
            this.buttonRef.button!.nativeElement.style.setProperty('width', `${width}px`, 'important');
        }
        setTimeout(() => {
            this._menuWidth = element.clientWidth;
        });
    }

    get menuWidth(): string {
        return `${this._menuWidth}px`;
    }

    @HostListener('window:resize', ['$event'])
    WindowResize() {
        setTimeout(() => {
            this.ResizeButton();
        }, 350);
        // need to wait for the resize event to complete before recalculating the button width
    }

}
